module.exports = __webpack_public_path__ + "img/tax_b2@2x.d4aaec58.png";